import { useRestClient } from '@/contexts/QueryProvider'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
// import { json } from '@/catalog-apps/mock-data/data-activity-log/data-activity-log-skills.json'
// import { MessagesDataAssetsTDataAssetActivity } from '../types'

// const mockData = json as MessagesDataAssetsTDataAssetActivity[]

export function useGetDataAssetActivityLogByIds({ entityId, dataAssetId }: { entityId: number; dataAssetId: number }) {
  const { getDataAssetApiGetSpecificDataAssetSummary } = useRestClient()
  const { appId, projectId } = useAppContext()

  return getDataAssetApiGetSpecificDataAssetSummary.useSuspenseQuery(
    { path: { applicationId: appId!, projectId: projectId!, entityId, dataAssetId } }
    // { select: (_) => mockData }
    // { select: (_) => mockData.slice(0, 7) }
  )
}

export function useInvalidateDataAssetActivityLogByIds({
  entityId,
  dataAssetId,
}: {
  entityId: number
  dataAssetId: number
}) {
  const { getDataAssetApiGetSpecificDataAssetSummary } = useRestClient()
  const { appId, projectId } = useAppContext()
  return () =>
    getDataAssetApiGetSpecificDataAssetSummary.invalidateQueries({
      parameters: {
        path: {
          applicationId: appId!,
          projectId: projectId!,
          entityId,
          dataAssetId,
        },
      },
    })
}
